import Link from "next/link";
import clsx from "clsx";
import { Card } from "@chef/components";
import { BRAND_PATHS } from "@chef/constants";
import { useRecruitmentDataQuery } from "@chef/state-management";
import { intl } from "./TellAFriendOverview.Intl";

interface ReferralHistoryBlockProps {
  type?: "recruitedCustomers" | "redeemedDiscounts";
  referralCount: number;
}

const ReferralHistoryBlock = ({
  type = "recruitedCustomers",
  referralCount,
}: ReferralHistoryBlockProps) => {
  return (
    <div
      className={clsx(
        type === "recruitedCustomers" ? "bg-grey-3" : "bg-informationBG",
        "px-4 mt-3 text-sm",
      )}
    >
      <div className="flex items-center justify-between w-full py-4">
        <strong>
          {type === "recruitedCustomers"
            ? intl.ACCOUNTS_CREATED_WITH_YOUR_CODE
            : intl.YOUR_RECEIVED_DISCOUNTS}
        </strong>

        <strong className="mr-3.5 flex items-center flex-end">
          {referralCount}
        </strong>
      </div>
    </div>
  );
};

export const TellAFriendOverview = () => {
  const { data: recruitmentDataQuery } = useRecruitmentDataQuery();

  const recruitedCustomers =
    recruitmentDataQuery?.recruitmentData.recruitedCustomers ?? 0;

  const redeemedDiscounts =
    recruitmentDataQuery?.recruitmentData.redeemedDiscounts ?? 0;

  return (
    <Card className="py-8 mt-8 text-center">
      <h2 className="mb-4 text-lg">
        <strong>{intl.YOUR_HISTORY}</strong>
      </h2>
      <p className="text-sm">
        {intl.ALL_YOUR_REFERRALS_SINCE_YOU_CREATED_YOUR_ACCOUNT}
      </p>

      <ReferralHistoryBlock referralCount={recruitedCustomers} />

      <ReferralHistoryBlock
        type="redeemedDiscounts"
        referralCount={redeemedDiscounts}
      />

      <div className="mt-6 text-sm text-center">
        <p>
          <strong>{intl.WHEN_WILL_I_RECIEVE_MY_DISCOUNT}</strong>
        </p>
        <p>{intl.AS_SOON_AS_YOUR_FRIEND_HAS_RECEIVED_HIS_FIRST_DELIVERY}</p>

        <Link
          href={BRAND_PATHS.MY_DISCOUNTS_PAGE}
          passHref
          className="underline text-primary"
        >
          <strong>{intl.SHOW_MY_ACTIVE_DISCOUNTS}</strong>
        </Link>
      </div>
    </Card>
  );
};
